export enum Roles {
  Ateneo = 'Ateneo',
  Configuracion = 'Configuración',
  Administrador = 'Administrador'
}

export const ALL_ROLES: string[] = Object.values(Roles);

export const ERROR_LICENSE = 'User license has expired';

export interface Model {
  id: string;
  svg: string;
}

export const modelList: Model[] = [
  { id: 'GENERIC', svg: 'generic' },
  { id: 'MAXUNO-1C', svg: 'maxuno1c' },
  { id: 'MAXUNO-2C', svg: 'maxuno2c' },
  { id: 'MAXUNO-3C', svg: 'maxuno3c' },
  { id: 'PYROS-600', svg: 'pyros600' },
  { id: 'PYROS-1200', svg: 'pyros1200' },
  { id: 'PYROS-1500', svg: 'pyros1500' },
  { id: 'WATEX-600', svg: 'WATEX600MMS' },
  { id: 'WATEX-1200', svg: 'WATEX1200MMS' },
  { id: 'WATEX-1500', svg: 'WATEX1500MMS' },
  { id: 'VIAL', svg: 'Vial' },
  { id: 'SENSOR', svg: 'sensor' },
];

export enum SubIcon {
  UNCONNECTED = 'disconnected',
  WARNING = 'warning',
  ERROR = 'error',
}
